interface DocumentViewerProps {
	filePath: string;
}

export const DocumentViewer = ({ filePath }: DocumentViewerProps) => {
	const fileName = filePath.split("/").pop() || "document.pdf";

	return (
		<a
			href={filePath}
			target="_blank"
			rel="noopener noreferrer"
			className="text-sm text-blue-600 hover:text-blue-700 hover:underline"
		>
			{fileName}
		</a>
	);
};
